import React, { Component } from 'react';
import { Button, Spin } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import Filter from './Filter';
import TableC from '../../basicElement/TableC';
import SideNav from '../MemberSider';
import moment from 'moment';

const monthFormat = "YYYY-MM";

class StaffEfficiency extends Component {
    state = {
        data: [],
        loading: false,
        sortParams: {},
        searchParams: {
            begin: moment().format(monthFormat),
            end: moment().format(monthFormat),
        },
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(searchParams);
        const options = {
            method: 'POST',
            url: API_URL.member.queryInvestigationUserEfficiency,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const params = this.splitParams(searchParams);
        const url = API_URL.member.exportInvestigationUserEfficiency;
        ExportUtil.export({ ...sortParams, ...params }, null, url);
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            sorter: true,
            width: 80,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            sorter: true,
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            sorter: true,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            sorter: true,
            width: 160,
        }, {
            title: '人员状态',
            dataIndex: 'employeeStatus',
            key: 'employeeStatus',
            sorter: true,
        }, {
            title: '完成访视数',
            dataIndex: 'visitCount',
            key: 'visitCount',
            sorter: true,
        }, {
            title: '完成访视数/消耗FTE数',
            dataIndex: 'visitCountFte',
            key: 'visitCountFte',
            sorter: true,
        }, {
            title: '方案违背数',
            dataIndex: 'violationAmount',
            key: 'violationAmount',
            sorter: true,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, searchParams, sortParams } = this.state;
        return (
            <div className="content">
                <SideNav />
                <div className="main">
                    <Filter
                        search={this.search}
                        params={searchParams}
                        onChange={this.handleFilterChange}
                        buttons={[
                            <Button key="export" type="primary" onClick={this.export}>导出</Button>
                        ]}
                    />
                    <TableC
                        data={data}
                        scorllY={500}
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        className="staffEfficiency"
                    />
                </div>
            </div>
        );
    }
}

export default StaffEfficiency;


// WEBPACK FOOTER //
// ./src/components/member/staffEfficiency/index.js